<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">费用明细</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <span class="hint">默认显示近三月费用</span>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="
        !hideInAddInsurance &&
        !hideInInsuranceEdit &&
        !isShowDetails &&
        !hideInBatchAddCost &&
        !hideInRepairData
      "
    >
      <section class="searchBox">
        <span class="addStyle">
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
          <a-button
            v-show="
              (userSupport || userCashier || userFinance || userBOSS) &&
              showIsSearch
            "
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            @click="hideInAddInsurance = !hideInAddInsurance"
            >增加</a-button
          >
          <a-button
            v-show="
              (userSupport || userCashier || userFinance || userBOSS) &&
              showIsSearch
            "
            style="margin-right: 20px"
            icon="plus"
            @click="hideInBatchAddCost = !hideInBatchAddCost"
            >批量处理费用</a-button
          >
        </span>
        <span v-show="showIsSearch">
          <label>结算类型：</label>
          <a-radio-group v-model="type">
            <a-radio :value="1">应收</a-radio>
            <a-radio :value="2">应付</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>票据：</label>
          <a-radio-group v-model="is_ticket">
            <a-radio :value="2">票据齐全</a-radio>
            <a-radio :value="1">票据不全</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>银行流水编号：</label>
          <a-radio-group v-model="is_bank_flow_num">
            <a-radio :value="2">有</a-radio>
            <a-radio :value="1">无</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>外包平台：</label>
          <a-radio-group v-model="is_platform">
            <a-radio :value="2">使用</a-radio>
            <a-radio :value="1">未使用</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch && is_platform == 2">
          <label>外包平台名称：</label>
          <a-select style="width: 120px" v-model="finance_platform_id">
            <a-select-option
              :value="element.id"
              v-for="(element, k) in platformList"
              :key="k"
            >
              {{ element.name }}
            </a-select-option>
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>状态：</label>
          <a-select style="width: 140px" v-model="status" :allowClear="true">
            <a-select-option :value="20">待项目负责人审核</a-select-option>
            <a-select-option :value="21">项目负责人驳回</a-select-option>
            <a-select-option :value="30">待财务审核</a-select-option>
            <a-select-option :value="31">财务驳回</a-select-option>
            <a-select-option :value="40">待打款/待收款</a-select-option>
            <a-select-option :value="41">出纳驳回</a-select-option>
            <!-- <a-select-option :value="42">已入账/已出账</a-select-option> -->
            <a-select-option :value="50">结算完成</a-select-option>
            <a-select-option :value="60">支付宝支付失败</a-select-option>
            <!-- <a-select-option :value="100">已作废</a-select-option> -->
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>新增类型：</label>
          <a-radio-group v-model="from_type">
            <a-radio :value="1">后台</a-radio>
            <a-radio :value="2">报销</a-radio>
            <a-radio :value="4">预支</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>费用大类：</label>
          <a-select
            :allowClear="true"
            v-model="pid"
            style="width: 120px"
            @change="selectedPID"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
          >
            <a-select-option
              v-for="item in parentsList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>费用类型：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            :allowClear="true"
            style="width: 120px"
            v-model="finance_type_id"
          >
            <a-select-option
              v-for="item in costTypeList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>客户名称：</label>
          <a-select
            :allowClear="true"
            v-model="customer_id"
            style="min-width: 160px"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in customerList"
              :key="element.id"
              :value="element.id"
              >{{ element.customer_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>行业：</label>
          <a-select
            :allowClear="true"
            placeholder="请选择行业类型"
            style="width: 100px"
            v-model="trade_id"
          >
            <a-select-option
              v-for="(item, i) in tradeList"
              :key="i"
              :value="item.id"
              >{{ item.trade_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            :allowClear="true"
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo && showIsSearch">
          <label>省级项目：</label>
          <a-select
            :allowClear="true"
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-show="showIsSearch"
            :allowClear="true"
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              v-for="item in proListThree"
              :key="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>签约主体：</label>
          <a-select
            :allowClear="true"
            mode="multiple"
            v-model="company_id"
            :maxTagCount="3"
            style="min-width: 160px"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in comList"
              :key="element.id"
              :value="element.id"
              >{{ element.company_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <a-select
            :allowClear="true"
            style="width: 140px; margin-right: 6px"
            v-model="time_type"
          >
            <a-select-option :value="1">费用归属日期</a-select-option>
            <a-select-option :value="2">开票日期</a-select-option>
            <a-select-option :value="6">项目审核日期</a-select-option>
            <a-select-option :value="7">财务审核日期</a-select-option>
            <a-select-option :value="3">入账日期</a-select-option>
            <a-select-option :value="4">出账日期</a-select-option>
            <a-select-option :value="5">创建日期</a-select-option>
          </a-select>
          <a-range-picker
            v-model="date"
            @change="changeDate"
            style="width: 230px"
            :ranges="{
              今天: [moment(), moment()],
              本月: [moment().startOf('month'), moment()],
              上月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month'),
              ],
            }"
            :placeholder="['开始时间', '结束时间']"
          />
        </span>
        <span v-show="showIsSearch">
          <label>结算方式：</label>
          <a-select
            :allowClear="true"
            style="width: 140px; margin-right: 6px"
            v-model="paytype"
          >
            <a-select-option :value="1">支付宝</a-select-option>
            <a-select-option :value="2">银行卡</a-select-option>
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>打款至：</label>
          <a-select
            :allowClear="true"
            style="width: 140px; margin-right: 6px"
            v-model="out_account_type"
          >
            <a-select-option :value="2">员工</a-select-option>
            <a-select-option :value="3">三方</a-select-option>
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width: 200px"
            placeholder="费用名称|编号|金额|提交人员"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
          <a-button
            v-show="showIsSearch"
            class="resetStyle"
            @click="downloadCost"
          >
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button
            style="
              background-color: #67c23a;
              border-color: #67c23a;
              color: #fff;
            "
            icon="file-protect"
            v-show="!addProAuditIsShow && showIsSearch && userBOSS"
            @click="batchProAudit"
            >项目负责人批量审核</a-button
          >
          <a-button @click="cancelTask" v-show="addProAuditIsShow"
            >取消</a-button
          >
          <a-button
            style="
              background-color: #e6a23c;
              border-color: #e6a23c;
              color: #fff;
            "
            v-show="addProAuditIsShow"
            @click="sureProAudit"
            >确认审核通过</a-button
          >
          <a-button
            style="
              background-color: #67c23a;
              border-color: #67c23a;
              color: #fff;
            "
            icon="file-protect"
            v-show="!financeIsShow && showIsSearch && userFinance"
            @click="batchFinance"
            >财务批量审核</a-button
          >
          <a-button @click="cancelTask" v-show="financeIsShow">取消</a-button>
          <a-button
            style="
              background-color: #e6a23c;
              border-color: #e6a23c;
              color: #fff;
            "
            v-show="financeIsShow"
            @click="sureFinanceAudit"
            >财务确认审核</a-button
          >
          <a-button
            style="
              background-color: #67c23a;
              border-color: #67c23a;
              color: #fff;
            "
            icon="file-protect"
            v-show="!invoiceIsShow && showIsSearch && userFinance"
            @click="batchInvoice"
            >待开票批量审核</a-button
          >
          <a-button @click="cancelTask" v-show="invoiceIsShow">取消</a-button>
          <a-button
            style="
              background-color: #e6a23c;
              border-color: #e6a23c;
              color: #fff;
            "
            v-show="invoiceIsShow"
            @click="sureInvoiceAudit"
            >确认审核待开票</a-button
          >
          <a-button
            style="
              background-color: #67c23a;
              border-color: #67c23a;
              color: #fff;
            "
            icon="transaction"
            v-show="!addTaskIsShow && showIsSearch && userCashier"
            @click="batchTask"
            >批量出/入账</a-button
          >
          <a-button @click="cancelTask" v-show="addTaskIsShow">取消</a-button>
          <a-button
            style="
              background-color: #e6a23c;
              border-color: #e6a23c;
              color: #fff;
            "
            v-show="addTaskIsShow"
            @click="addTaskAffirm"
            >确认出/入帐</a-button
          >
          <a-button
            style="
              background-color: #67c23a;
              border-color: #67c23a;
              color: #fff;
            "
            icon="file-protect"
            v-show="!ticketIsShow && showIsSearch && userFinance"
            @click="batchTicket"
            >批量补票</a-button
          >
          <a-button @click="cancelTask" v-show="ticketIsShow">取消</a-button>
          <a-button
            style="
              background-color: #e6a23c;
              border-color: #e6a23c;
              color: #fff;
            "
            v-show="ticketIsShow"
            @click="sureTicketAudit"
            >确认补票</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-show="addTaskIsShow">
                <a-checkbox :checked="checkedTask" @change="onCheckAllChange"
                  >全选</a-checkbox
                >
              </th>
              <th v-show="addProAuditIsShow">
                <a-checkbox
                  :checked="checkedProAudit"
                  @change="onCheckAllProAudit"
                  >全选</a-checkbox
                >
              </th>
              <th v-show="financeIsShow">
                <a-checkbox
                  :checked="checkedFinanceAudit"
                  @change="onCheckAllFinanceAudit"
                  >全选</a-checkbox
                >
              </th>
              <th v-show="invoiceIsShow">
                <a-checkbox
                  :checked="checkedInvoiceAudit"
                  @change="onCheckAllInvoiceAudit"
                  >全选</a-checkbox
                >
              </th>
              <th v-show="ticketIsShow">
                <a-checkbox
                  :checked="checkedTicketAudit"
                  @change="onCheckAllTicketAudit"
                  >全选</a-checkbox
                >
              </th>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <!-- <td></td> -->
              <td v-show="addTaskIsShow"></td>
              <td v-show="addProAuditIsShow"></td>
              <td v-show="financeIsShow"></td>
              <td v-show="invoiceIsShow"></td>
              <td v-show="ticketIsShow"></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0">
              <td>合计</td>
              <td v-show="addTaskIsShow"></td>
              <td v-show="addProAuditIsShow"></td>
              <td v-show="financeIsShow"></td>
              <td v-show="invoiceIsShow"></td>
              <td v-show="ticketIsShow"></td>
              <td></td>
              <!-- <td></td> -->
              <td></td>
              <td></td>
              <td></td>
              <td>{{ Number(count_data.total_amount) }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td v-show="addTaskIsShow" class="changeTask">
                <img
                  @click="changeTaskOnly(i)"
                  v-show="item.isChange && item.status == 40"
                  src="../../assets/home/xuanzhong.png"
                  alt
                />
                <img
                  @click="changeTaskOnly(i)"
                  v-show="!item.isChange && item.status == 40"
                  src="../../assets/home/weixuanzhong.png"
                  alt
                />
                <img
                  v-show="item.status != 40"
                  src="../../assets/home/jinzhixuanzhong.png"
                  alt
                />
              </td>
              <td v-show="addProAuditIsShow" class="changeTask">
                <img
                  @click="proAuditOnly(i)"
                  v-show="
                    item.isProAudit &&
                    item.status == 20 &&
                    item.is_my_project == 1
                  "
                  src="../../assets/home/xuanzhong.png"
                  alt
                />
                <img
                  @click="proAuditOnly(i)"
                  v-show="
                    !item.isProAudit &&
                    item.status == 20 &&
                    item.is_my_project == 1
                  "
                  src="../../assets/home/weixuanzhong.png"
                  alt
                />
                <img
                  v-show="item.status != 20 || item.is_my_project != 1"
                  src="../../assets/home/jinzhixuanzhong.png"
                  alt
                />
              </td>
              <td v-show="financeIsShow" class="changeTask">
                <img
                  @click="financeAuditOnly(i)"
                  v-show="
                    item.isFinanceAudit &&
                    userFinance &&
                    item.status == 30 &&
                    item.type == 2
                  "
                  src="../../assets/home/xuanzhong.png"
                  alt
                />
                <img
                  @click="financeAuditOnly(i)"
                  v-show="
                    !item.isFinanceAudit &&
                    userFinance &&
                    item.status == 30 &&
                    item.type == 2
                  "
                  src="../../assets/home/weixuanzhong.png"
                  alt
                />
                <img
                  v-show="item.status != 30 || !userFinance || item.type != 2"
                  src="../../assets/home/jinzhixuanzhong.png"
                  alt
                />
              </td>
              <td v-show="invoiceIsShow" class="changeTask">
                <img
                  @click="invoiceAuditOnly(i)"
                  v-show="
                    item.isInvoiceAudit &&
                    userFinance &&
                    item.status == 30 &&
                    item.type == 1
                  "
                  src="../../assets/home/xuanzhong.png"
                  alt
                />
                <img
                  @click="invoiceAuditOnly(i)"
                  v-show="
                    !item.isInvoiceAudit &&
                    userFinance &&
                    item.status == 30 &&
                    item.type == 1
                  "
                  src="../../assets/home/weixuanzhong.png"
                  alt
                />
                <img
                  v-show="item.status != 30 || !userFinance || item.type != 1"
                  src="../../assets/home/jinzhixuanzhong.png"
                  alt
                />
              </td>
              <td v-show="ticketIsShow" class="changeTask">
                <img
                  @click="ticketAuditOnly(i)"
                  v-show="
                    item.isTicketAudit &&
                    userFinance &&
                    item.status == 50 &&
                    item.is_ticket != 2
                  "
                  src="../../assets/home/xuanzhong.png"
                  alt
                />
                <img
                  @click="ticketAuditOnly(i)"
                  v-show="
                    !item.isTicketAudit &&
                    userFinance &&
                    item.status == 50 &&
                    item.is_ticket != 2
                  "
                  src="../../assets/home/weixuanzhong.png"
                  alt
                />
                <img
                  v-show="
                    item.status != 50 || !userFinance || item.is_ticket == 2
                  "
                  src="../../assets/home/jinzhixuanzhong.png"
                  alt
                />
              </td>
              <td>
                {{
                  item.finance_date
                    .substring(0, 10)
                    .replace("-", ".")
                    .replace("-", ".")
                }}
              </td>
              <td>{{ item.project_name }}</td>
              <td>{{ item.pname + "-" + item.finance_type_name }}</td>
              <td>
                {{
                  item.name.length > 8
                    ? item.name.substring(0, 8) + "..."
                    : item.name
                }}
              </td>
              <td>
                {{
                  item.detail.length > 10
                    ? item.detail.substring(0, 10) + "..."
                    : item.detail
                }}
              </td>
              <td>
                <p v-show="item.type == 1">
                  {{
                    "+" +
                    (Number(item.amount) + Number(item.pay_service)).toFixed(2)
                  }}
                </p>
                <p v-show="item.type == 2">
                  {{
                    "-" +
                    (Number(item.amount) + Number(item.pay_service)).toFixed(2)
                  }}
                </p>
              </td>
              <!-- <td>{{item.create_user_name}}</td> -->
              <td>
                <p v-show="item.status == 20">待项目负责人审核</p>
                <p v-show="item.status == 21">项目负责人驳回</p>
                <p v-show="item.type == 1 && item.status == 30">待开票</p>
                <p v-show="item.type == 2 && item.status == 30">待财务审核</p>
                <p v-show="item.status == 31">财务驳回</p>
                <p v-show="item.type == 1 && item.status == 40">待收款</p>
                <p v-show="item.type == 2 && item.status == 40">待付款</p>
                <p v-show="item.status == 41">出纳驳回</p>
                <p v-show="item.type == 1 && item.status == 42">已入账</p>
                <p v-show="item.type == 2 && item.status == 42">已出账</p>
                <p v-show="item.status == 50">结算完成</p>
                <p v-show="item.status == 100">费用作废</p>
                <p v-show="item.status == 60">支付宝支付失败</p>
              </td>
              <td class="operation">
                <a
                  style="color: #67c23a"
                  v-show="
                    item.is_my_self == 1 &&
                    item.from_type != 2 &&
                    item.from_type != 4 &&
                    item.status != 30 &&
                    item.status != 40 &&
                    item.status != 42 &&
                    item.status != 50 &&
                    item.status != 100
                  "
                  @click="editPage(item)"
                  >编辑</a
                >
                <a style="color: #909399" @click="detailsPage(item)">详情</a>
                <a
                  style="color: #f56c6c"
                  v-show="item.status == 20 && item.is_my_project == 1"
                  @click="auditManager(item)"
                  >审核</a
                >
                <a
                  style="color: #f56c6c"
                  v-show="item.type == 1 && userFinance && item.status == 30"
                  @click="auditFinance(item)"
                  >待开票</a
                >
                <a
                  style="color: #f56c6c"
                  v-show="item.type == 2 && userFinance && item.status == 30"
                  @click="auditFinance(item)"
                  >财务审核</a
                >
                <a
                  v-show="
                    userCashier && (item.status == 40 || item.status == 42)
                  "
                  style="color: #f56c6c"
                  @click="auditCashier(item)"
                  >{{ item.type == 1 ? "入账" : "出账" }}</a
                >
                <a
                  style="color: #f56c6c"
                  v-show="item.status == 50"
                  @click="repairDataPage(item)"
                  >修复数据</a
                >
                <a
                  style="color: #e6a23c"
                  v-show="
                    item.status == 50 && item.is_ticket != 2 && userFinance
                  "
                  @click="auditTicket(item)"
                  >缺票</a
                >
                <a
                  style="color: #e6a23c"
                  v-show="
                    item.status == 50 && item.bank_flow_num == '' && userCashier
                  "
                  @click="auditBankFlowNum(item)"
                  >缺流水</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addCost v-on:hideInAdd="hideInAdd" v-show="hideInAddInsurance" />
    <!-- 增加 end-->
    <!-- 批量新增应付账款 -->
    <batchAddCost
      v-show="hideInBatchAddCost"
      v-on:hideInAddBetch="hideInAddBetch"
    />
    <!-- 批量新增应付账款 end -->
    <!-- 编辑 -->
    <costEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInInsuranceEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
    <!-- 修复数据 -->
    <repairData
      v-show="hideInRepairData"
      :repairDataDetails="repairDataDetails"
      v-on:hideInRepairDataPage="hideInRepairDataPage"
    />
    <!-- 修复数据 end -->
    <!-- 详情 -->
    <costDetails
      v-on:hideInHandle="hideInHandle"
      v-show="isShowDetails"
      :detailsVal="detailsVal"
    />
    <!-- 详情 end -->
    <!-- 负责人审核 -->
    <auditManager
      :auditManagerDetails="auditManagerDetails"
      v-if="showIsAuditManager"
      v-on:hideInDialogManager="hideInDialogManager"
    />
    <!-- 负责人审核 end -->
    <!-- 财务审核 -->
    <auditFinance
      v-on:hideInDialogFinance="hideInDialogFinance"
      v-if="showIsAuditFinance"
      :auditFinaceDetails="auditFinaceDetails"
    />
    <!-- 财务审核 end -->
    <!-- 出纳审核 -->
    <auditCashier
      v-on:hideInDialogCashier="hideInDialogCashier"
      v-if="showIsAuditCashier"
      :auditCashierDetails="auditCashierDetails"
    />
    <!-- 出纳审核 end -->
    <!-- 批量出入帐 -->
    <batchCredit
      v-show="showIsBatchCredit"
      v-on:hideInDialogBatchCredit="hideInDialogBatchCredit"
      :batchCreditIds="batchCreditIds"
    />
    <!-- 批量出入帐 end -->
    <!-- 缺银行流水编号 -->
    <aside class="dialogsBox" v-show="showIsFlowNum">
      <div>
        <h3>补齐流水</h3>
        <a @click="showIsFlowNum = false" class="close"
          ><a-icon style="color: #666" type="close-circle"
        /></a>
        <ul v-if="flowNumDetails != ''">
          <li>
            <label>项目：</label>
            <p>{{ flowNumDetails.project_name }}</p>
          </li>
          <li>
            <label>费用名称：</label>
            <p>{{ flowNumDetails.name }}</p>
          </li>
          <li>
            <label>费用金额：</label>
            <p>{{ flowNumDetails.amount }}</p>
          </li>
          <li>
            <label><i>*</i>银行流水编号：</label>
            <a-input v-model="bank_flow_num" style="width: 50%" />
          </li>
        </ul>
        <div>
          <a-button @click="showIsFlowNum = false">取消</a-button>
          <a-button type="primary" @click="polishingStatement"> 确认 </a-button>
        </div>
      </div>
    </aside>
    <!-- 缺银行流水编号 end -->
    <!-- 财务批量审核应付 -->
    <batchFinanceModel
      v-on:hideInDialogBatchFinanceAudit="hideInDialogBatchFinanceAudit"
      v-show="showIsBatchFinanceModel"
      :batchFinanceIds="batchFinanceIds"
    />
    <!-- 财务批量审核应付 end -->
    <!-- 待开票批量审核 -->
    <batchInvoiceModel
      v-show="showIsBatchInvoiceModel"
      :batchInvoiceIds="batchInvoiceIds"
      v-on:hideInDialogBatchInvoiceAudit="hideInDialogBatchInvoiceAudit"
    />
    <!-- 待开票批量审核 end -->
    <!-- 补票批量操作 -->
    <batchTicketModel
      v-show="showIsBatchTicketModel"
      :batchTicketIds="batchTicketIds"
      v-on:hideInDialogBatchTicketAudit="hideInDialogBatchTicketAudit"
    />
    <!-- 补票批量操作 end-->
  </div>
</template>
<script>
import axios from "axios";
import addCost from "@/components/money/addCost"; //增加
import batchAddCost from "@/components/money/batchAddCost"; //批量增加
import costEdit from "@/components/money/costEdit"; //编辑
import repairData from "@/components/money/repairData"; //修复数据
import costDetails from "@/components/money/costDetails"; //详情
import auditManager from "@/components/money/auditManager"; //负责人审核
import auditFinance from "@/components/money/auditFinance"; //财务审核
import auditCashier from "@/components/money/auditCashier"; //出纳审核
import batchCredit from "@/components/money/batchCredit"; //批量出入帐
import batchFinanceModel from "@/components/money/batchFinanceModel"; //财务批量审核
import batchInvoiceModel from "@/components/money/batchInvoiceModel"; //待开票批量审核
import batchTicketModel from "@/components/money/batchTicketModel"; //补票批量审核
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: {
    addCost,
    costEdit,
    costDetails,
    auditManager,
    auditFinance,
    auditCashier,
    batchCredit,
    batchAddCost,
    repairData,
    batchFinanceModel,
    batchInvoiceModel,
    batchTicketModel,
  },
  data() {
    return {
      paytype: "",
      out_account_type: "",
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddInsurance: false,
      hideInInsuranceEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: [
        "费用所属日期",
        // "类型",
        "项目",
        "费用类型",
        "费用名称",
        "费用明细",
        "费用总金额",
        "状态",
        "操作",
      ],
      query_field: "",
      status: "",
      type: "",
      showIsSearch: false,
      isShowDetails: false,
      detailsVal: {},
      parentsList: [],
      costTypeList: [],
      showIsAuditManager: false,
      auditManagerDetails: {},
      showIsAuditFinance: false,
      auditFinaceDetails: {},
      pid: "",
      userFinance: false,
      userCashier: false,
      date: [
        moment()
          .month(moment().month() - 3)
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      showIsAuditCashier: false,
      auditCashierDetails: {},
      start_date: moment()
        .month(moment().month() - 3)
        .format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      time_type: 1,
      proList: [],
      project_id: "",
      company_id: [],
      customer_id: "",
      comList: [],
      customerList: [],
      finance_type_id: "",
      addTaskIsShow: false,
      distance: false,
      showIsBatchCredit: false,
      batchCreditIds: [],
      count_data: "",
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      hideInBatchAddCost: false,
      from_type: "",
      is_bank_flow_num: "",
      is_ticket: "",
      userBOSS: false,
      tradeList: [],
      trade_id: "",
      showIsFlowNum: false,
      flowNumDetails: {},
      bank_flow_num: "",
      hideInRepairData: false,
      repairDataDetails: {},
      addProAuditIsShow: false,
      checkedTask: false,
      checkedProAudit: false,
      financeIsShow: false,
      checkedFinanceAudit: false,
      showIsBatchFinanceModel: false,
      batchFinanceIds: [],
      userSupport: false,
      is_platform: "",
      finance_platform_id: "",
      platformList: [],
      invoiceIsShow: false,
      showIsBatchInvoiceModel: false,
      checkedInvoiceAudit: false,
      batchInvoiceIds: [],
      showIsBatchTicketModel: false,
      ticketIsShow: false,
      checkedTicketAudit: false,
      batchTicketIds: [],
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  mounted() {
    let roleList = window.localStorage.getItem("xnserve-authority").split(",");
    this.userFinance = roleList.includes("财务");
    this.userCashier = roleList.includes("出纳");
    this.userBOSS = roleList.includes("BOSS");
    this.userSupport = roleList.includes("运营支持");
    this.getData(); //获取列表
    this.getCompany(); //获取公司
    this.getCustomer(); //获取客户
    this.getParents(); //获取费用大类
    this.getType(-1); //获取费用类型
    this.getProOne(); //获取一级项目列表
    this.getPro(); //获取项目
    this.getTrade(); //获取行业数据
    this.getPlatform(); //获取外包平台
  },
  watch: {
    is_platform() {
      if (this.is_platform == 1) {
        this.finance_platform_id = "";
      }
    },
  },
  methods: {
    moment,
    getPlatform() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_platform/lists";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 10000,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.platformList = res.data.data.data;
            // console.log(this.platformList);
          }
        });
    },
    hideInDialogBatchFinanceAudit(msg) {
      this.showIsBatchFinanceModel = false;
      if (msg) {
        this.reload();
      }
    },
    sureFinanceAudit() {
      let ids = [];
      this.data.forEach((element, i) => {
        if (element.isFinanceAudit) {
          ids.push(element.id);
        }
      });
      let _this = this;
      if (ids == "") {
        this.$message.warning("请至少选择一项费用");
      } else {
        this.financeIsShow = false;
        this.showIsBatchFinanceModel = true;
        this.batchFinanceIds = ids;
      }
    },

    onCheckAllFinanceAudit(e) {
      this.checkedFinanceAudit = e.target.checked;
      this.data.forEach((element, i) => {
        if (this.userFinance && element.status == 30 && element.type == 2) {
          return (this.data[i].isFinanceAudit = e.target.checked);
        }
      });
      this.$forceUpdate();
    },
    financeAuditOnly(i) {
      this.data[i].isFinanceAudit = !this.data[i].isFinanceAudit;
      this.$forceUpdate();
    },
    hideInDialogBatchInvoiceAudit(msg) {
      this.showIsBatchInvoiceModel = false;
      if (msg) {
        this.reload();
      }
    },
    sureInvoiceAudit() {
      let ids = [];
      this.data.forEach((element, i) => {
        if (element.isInvoiceAudit) {
          ids.push(element.id);
        }
      });
      let _this = this;
      if (ids == "") {
        this.$message.warning("请至少选择一项费用");
      } else {
        this.invoiceIsShow = false;
        this.showIsBatchInvoiceModel = true;
        this.batchInvoiceIds = ids;
      }
    },
    onCheckAllInvoiceAudit(e) {
      this.checkedInvoiceAudit = e.target.checked;
      this.data.forEach((element, i) => {
        if (this.userFinance && element.status == 30 && element.type == 1) {
          return (this.data[i].isInvoiceAudit = e.target.checked);
        }
      });
      this.$forceUpdate();
    },
    invoiceAuditOnly(i) {
      this.data[i].isInvoiceAudit = !this.data[i].isInvoiceAudit;
      this.$forceUpdate();
    },
    batchFinance() {
      this.financeIsShow = true;
      this.addProAuditIsShow = false;
      this.addTaskIsShow = false;
      this.invoiceIsShow = false;
      this.ticketIsShow = false;
    },
    batchInvoice() {
      this.invoiceIsShow = true;
      this.addProAuditIsShow = false;
      this.addTaskIsShow = false;
      this.financeIsShow = false;
      this.ticketIsShow = false;
    },
    batchTicket() {
      this.ticketIsShow = true;
      this.invoiceIsShow = false;
      this.addProAuditIsShow = false;
      this.addTaskIsShow = false;
      this.financeIsShow = false;
    },
    onCheckAllTicketAudit(e) {
      this.checkedTicketAudit = e.target.checked;
      this.data.forEach((element, i) => {
        if (
          this.userFinance &&
          element.status == 50 &&
          element.is_ticket != 2
        ) {
          return (this.data[i].isTicketAudit = e.target.checked);
        }
      });
      this.$forceUpdate();
    },
    hideInDialogBatchTicketAudit(msg) {
      this.showIsBatchTicketModel = false;
      if (msg) {
        this.reload();
      }
    },
    ticketAuditOnly(i) {
      this.data[i].isTicketAudit = !this.data[i].isTicketAudit;
      this.$forceUpdate();
    },
    sureTicketAudit() {
      let ids = [];
      this.data.forEach((element, i) => {
        if (element.isTicketAudit) {
          ids.push(element.id);
        }
      });
      let _this = this;
      if (ids == "") {
        this.$message.warning("请至少选择一项费用");
      } else {
        this.ticketIsShow = false;
        this.showIsBatchTicketModel = true;
        this.batchTicketIds = ids;
      }
    },
    sureProAudit() {
      let ids = [];
      this.data.forEach((element, i) => {
        if (element.isProAudit) {
          ids.push(element.id);
        }
      });
      let _this = this;
      if (ids == "") {
        this.$message.warning("请至少选择一项费用");
      } else {
        this.addProAuditIsShow = false;
        this.$confirm({
          title: "项目负责人批量审核通过",
          content: "是否确认选择的" + ids.length + "条费用审核通过",
          cancelText: "取消",
          okText: "确认",
          onOk() {
            _this.batchProAuditHttp(ids);
          },
          onCancel() {},
        });
      }
    },
    batchProAuditHttp(ids) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/projectCheckPassBatch";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          ids: JSON.stringify(ids),
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("项目负责人批量审核成功");
            this.reload();
          }
        });
    },
    onCheckAllProAudit(e) {
      this.checkedProAudit = e.target.checked;
      this.data.forEach((element, i) => {
        if (element.status == 20 && element.is_my_project == 1) {
          return (this.data[i].isProAudit = e.target.checked);
        }
      });
      this.$forceUpdate();
    },
    proAuditOnly(i) {
      this.data[i].isProAudit = !this.data[i].isProAudit;
      this.$forceUpdate();
    },
    batchTask() {
      this.addTaskIsShow = true;
      this.addProAuditIsShow = false;
      this.financeIsShow = false;
      this.invoiceIsShow = false;
      this.ticketIsShow = false;
    },
    batchProAudit() {
      this.addProAuditIsShow = true;
      this.addTaskIsShow = false;
      this.financeIsShow = false;
      this.invoiceIsShow = false;
      this.ticketIsShow = false;
    },
    cancelTask() {
      this.addTaskIsShow = false;
      this.addProAuditIsShow = false;
      this.financeIsShow = false;
      this.checkedTask = false;
      this.checkedProAudit = false;
      this.checkedFinanceAudit = false;
      this.invoiceIsShow = false;
      this.ticketIsShow = false;
      this.data.forEach((element, i) => {
        this.data[i].isChange = false;
        this.data[i].isProAudit = false;
        this.data[i].isFinanceAudit = false;
        this.data[i].isInvoiceAudit = false;
        this.data[i].isTicketAudit = false;
        return;
      });
      this.$forceUpdate();
    },
    hideInRepairDataPage() {
      this.hideInRepairData = false;
      this.reload();
    },
    repairDataPage(item) {
      this.hideInRepairData = true;
      this.repairDataDetails = item;
    },
    polishingStatement() {
      let _this = this;
      if (this.bank_flow_num != "") {
        this.showIsFlowNum = false;
        this.$confirm({
          title: "提示",
          content: "是否确认该笔费用对应次银行流水编号",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            _this.polishingStatementHttp();
          },
          onCancel() {},
        });
      } else {
        this.$message.warning("标记*为必填！");
      }
    },
    polishingStatementHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/updateBankNumBy";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          bank_flow_num: this.bank_flow_num,
          ids: JSON.stringify([this.flowNumDetails.id]),
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("该笔费用流水已补齐！");
            this.reload();
          }
        });
    },
    auditBankFlowNum(item) {
      this.flowNumDetails = item;
      this.showIsFlowNum = true;
    },
    getTrade() {
      let url = this.httpsBasic.url + this.httpsBasic.trade + "Trade/tradeList";
      //   console.log(url)
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: 1,
        per_page: 1000,
      };
      axios.post(url, pramas).then((res) => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
        }
        // console.log(res);
      });
    },
    auditTicket(item) {
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "是否确定该笔费用已补齐票据？",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          _this.changeTicket(item);
        },
        onCancel() {},
      });
    },
    changeTicket(item) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/updateIsTicket";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: item.id,
          is_ticket: 2,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("修改成功！");
            this.reload();
          }
        });
    },
    hideInAddBetch() {
      this.hideInBatchAddCost = false;
      this.reload();
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    hideInHandle() {
      this.isShowDetails = false;
      this.reload();
    },
    hideInDialogBatchCredit(msg) {
      this.showIsBatchCredit = false;
      if (msg) {
        this.reload();
      }
    },
    changeTaskOnly(i) {
      this.data[i].isChange = !this.data[i].isChange;
      this.$forceUpdate();
    },
    addTaskAffirm() {
      let ids = [];
      this.data.forEach((element, i) => {
        if (element.isChange) {
          ids.push(element.id);
        }
      });
      let _this = this;
      if (ids == "") {
        this.$message.warning("请至少选择一项费用");
      } else {
        this.showIsBatchCredit = true;
        this.batchCreditIds = ids;
      }
    },
    onCheckAllChange(e) {
      this.checkedTask = e.target.checked;
      this.data.forEach((element, i) => {
        if (element.status == 40) {
          return (this.data[i].isChange = e.target.checked);
        }
      });
      this.$forceUpdate();
    },
    changeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      // console.log(dateString);
    },
    hideInDialogManager(msg) {
      this.showIsAuditManager = false;
      if (msg) {
        this.reload();
      }
    },
    auditManager(val) {
      this.auditManagerDetails = val;
      this.showIsAuditManager = true;
    },
    auditFinance(val) {
      this.auditFinaceDetails = val;
      this.showIsAuditFinance = true;
    },
    hideInDialogFinance(msg) {
      this.showIsAuditFinance = false;
      if (msg) {
        this.reload();
      }
    },
    auditCashier(val) {
      this.auditCashierDetails = val;
      this.showIsAuditCashier = true;
    },
    hideInDialogCashier(msg) {
      this.showIsAuditCashier = false;
      if (msg) {
        this.reload();
      }
    },
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0,
      };
      axios.post(url, params).then((res) => {
        if (res.data.code == 200) {
          this.parentsList = res.data.data;
        }
      });
    },
    selectedPID(id) {
      this.finance_type_id = "";
      this.getType(id); //获取费用类型
    },
    getType(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_type/getTwoLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: id,
      };
      axios.post(url, params).then((res) => {
        if (res.data.code == 200) {
          this.costTypeList = res.data.data;
          // console.log(this.costTypeList);
        }
      });
    },
    getCompany() {
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.comList = res.data.data.data;
            // console.log(this.comList);
          }
        });
    },
    getCustomer() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Customer/customerList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.customerList = res.data.data.data;
          }
        });
    },
    detailsPage(item) {
      this.detailsVal = item;
      this.isShowDetails = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function () {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddInsurance = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInInsuranceEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddInsurance = false;
      this.hideInInsuranceEdit = false;
      this.isShowDetails = false;
      this.hideInBatchAddCost = false;
      this.hideInRepairData = false;
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    downloadCost() {
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/listsDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&type=" +
        this.type +
        "&status=" +
        this.status +
        "&finance_type_id_pid=" +
        this.pid +
        "&finance_type_id=" +
        this.finance_type_id +
        "&time_type=" +
        this.time_type +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&project_id=" +
        pro +
        "&company_id=" +
        JSON.stringify(this.company_id) +
        "&customer_id=" +
        this.customer_id +
        "&from_type=" +
        this.from_type +
        "&is_ticket=" +
        this.is_ticket +
        "&is_bank_flow_num=" +
        this.is_bank_flow_num +
        "&trade_id=" +
        this.trade_id +
        "&finance_platform_id=" +
        this.finance_platform_id +
        "&is_platform=" +
        this.is_platform;
    },
    getData() {
      // console.log(this.$store.state.token);
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      // console.log(pro)
      this.loading = true;
      this.data = [];
      let url = this.httpsBasic.url + this.httpsBasic.finance + "Finance/lists";
      axios
        .post(url, {
          out_account_type: this.out_account_type,
          paytype: this.paytype,
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          type: this.type,
          status: this.status,
          finance_type_id_pid: this.pid,
          finance_type_id: this.finance_type_id,
          time_type: this.time_type,
          start_date: this.start_date,
          end_date: this.end_date,
          project_id: pro,
          from_type: this.from_type,
          is_ticket: this.is_ticket,
          is_bank_flow_num: this.is_bank_flow_num,
          company_id: JSON.stringify(this.company_id),
          customer_id: this.customer_id,
          trade_id: this.trade_id,
          is_platform: this.is_platform,
          finance_platform_id: this.finance_platform_id,
          token: window.localStorage.getItem("xnwfPcToken"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    editPage(detail) {
      this.hideInInsuranceEdit = true;
      this.editDetail = detail;
    },
    onReset() {
      this.paytype = "";
      this.out_account_type = "";
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.is_ticket = "";
      this.is_bank_flow_num = "";
      this.date = null;
      this.time_type = 1;
      this.project_id = "";
      this.company_id = [];
      this.customer_id = "";
      this.finance_type_id = "";
      this.from_type = "";
      this.type = "";
      this.pid = "";
      this.is_platform = "";
      this.finance_platform_id = "";
      this.status = "";
      this.trade_id = "";
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.getPro();
      this.page = 1;
      this.getData();
    },
  },
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  position: relative;
  .hint {
    position: absolute;
    right: 4%;
    top: 20px;
  }
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      button {
        margin-left: 10px;
      }
    }
  }
  .changeTask {
    img {
      height: 16px;
    }
  }
}
</style>
